import { PrimaryButton } from '@fluentui/react';
import Moment from 'moment';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import styles from './hospital.module.css';
import { ACTIONS, AuthRoutes } from '../../constants/Constants';
const ColumnsHospital = (handleClickGroup) =>{

    const [t, i18n] = useTranslation();

    return [
        {
  
          Header: t("hospital.name"),
          key:"name",
          accessor: "name",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true,
          Cell: ({ cell }) => (
            <>
            
             <Link   
                to={AuthRoutes.FIRMDETAILS+"?firmId="+cell.row.original.id+"&type="+0}
                state={{"firmId":cell.row.original.id,"type":0,"hospital":true,"action":ACTIONS.VIEW }}
                action={ACTIONS.VIEW}
                style={{color:'white'}}
              >
            <p className={styles.nameLink}>{cell.row.original.name}</p>
            </Link>
               </>
          )
        },
        {
          Header: t("hospital.code"),
          accessor: "code",
          key:"code",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true
        },
        {
          Header: t("hospital.address"),
          accessor: "address",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true
        },
        {
          Header: t("hospital.contact-details-1"),
          accessor: "contact1.name",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true
        },
        {
          Header:  t("hospital.contact-details-2"),
          accessor: "contact2.name",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true
        },
        {
            Header:  t("hospital.contact-details-3"),
            accessor: "contact3.name",
            className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true
        },
        {
            Header: t("hospital.created-at"),
            accessor: "createdTimeString",
            className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
            classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
            headerStyle: {},
            rowStyle: {},
            sorting: true
        },
        {
          Header: t("hospital.updated-at"),
          accessor: "updatedTimeString",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {},
          rowStyle: {},
          sorting: true
      },
      {
        Header:  t("hospital.status"),
        accessor: "active",
        className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1 blue",
        classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
        headerStyle: {},
        rowStyle: {},
        sorting: true,
        Cell: ({ cell }) => (
            <>{cell.row.values.active?t("hospital.active"):t("hospital.inactive")}</>
        )
    },
    {
          Header:  t("hospital.action"),
          accessor: "action",
          className: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          classChildName: "ms-Grid-col ms-sm6 ms-md4 ms-lg1",
          headerStyle: {textAlign:'left',marginLeft:100},
          rowStyle: {textAlign:'center'},
          sorting: false,
          Cell: ({ cell }) => (
            <>
               <PrimaryButton
               text={cell.row.values.active?t("hospital.deactivate"):t("hospital.activate")}
               //text={cell.row.values.action}
               onClick={(ev)=>handleClickGroup(ev,cell.row.original.id,cell)}
               style={{
                    width:"90%"
               }}
           />
             </>
            )
      }
  ]
}
;
export default ColumnsHospital;
